import React from 'react';
import TermsSection, { SectionText, BulletPoint } from './TermsSection';

const DataCollection = () => {
  return (
    <TermsSection title="3. No Student Data Collection / Institutional Responsibility">
      <SectionText>Campus Insights does not collect, store, or access:</SectionText>
      <BulletPoint>• Personal user identities</BulletPoint>
      <BulletPoint>• Educational records</BulletPoint>
      <BulletPoint>• Institutionally protected data</BulletPoint>
      <SectionText>
        All chatbot interactions are session-based and anonymous unless your institution explicitly configures otherwise.
      </SectionText>
      <SectionText>
        If your institution modifies default settings to connect Campus Insights to systems containing personal or educational records, the institution is solely responsible for ensuring compliance with FERPA and any other applicable laws.
      </SectionText>
    </TermsSection>
  );
};

export default DataCollection;
